/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Acwr_Risk_ModerateInputs */

const en_ui_acwr_risk_moderate = /** @type {(inputs: Ui_Acwr_Risk_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderate risk`)
};

const de_ui_acwr_risk_moderate = /** @type {(inputs: Ui_Acwr_Risk_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittleres Risiko`)
};

/**
* | output |
* | --- |
* | "Moderate risk" |
*
* @param {Ui_Acwr_Risk_ModerateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_acwr_risk_moderate = /** @type {((inputs?: Ui_Acwr_Risk_ModerateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Acwr_Risk_ModerateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_acwr_risk_moderate(inputs)
	return de_ui_acwr_risk_moderate(inputs)
});